/**
 * @generated SignedSource<<74e0cfcf1fc91196e7408c7a7f9191c7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FilterBooleanOperator = "AND" | "NOT" | "OR" | "%future added value";
export type FilterElementInput = {
  multiple?: FilterBooleanOperationInput | null | undefined;
  single?: FilterValueInput | null | undefined;
};
export type FilterValueInput = {
  name: string;
  operator?: string | null | undefined;
  value?: string | null | undefined;
  values?: ReadonlyArray<string | null | undefined> | null | undefined;
};
export type FilterBooleanOperationInput = {
  operands: ReadonlyArray<FilterElementInput>;
  operator: FilterBooleanOperator;
};
export type EditGroupRootQuery$variables = {
  accountGroupFilterElement?: FilterElementInput | null | undefined;
  groupUuid: any;
  policyCollectionFilterElement?: FilterElementInput | null | undefined;
  skip: boolean;
};
export type EditGroupRootQuery$data = {
  readonly userGroup?: {
    readonly displayName: string | null | undefined;
    readonly id: string;
    readonly name: string;
    readonly roleAssignmentPrincipal: any;
    readonly roleAssignments: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly role: {
            readonly name: string;
          };
          readonly target: {
            readonly __typename: string;
            readonly displayName?: string;
            readonly name?: string;
            readonly roleAssignmentTarget: any;
          };
        };
      }> | null | undefined;
    };
    readonly source: {
      readonly __typename: string;
    } | null | undefined;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"AccessControlSettingsPage_query" | "GroupFormFields_query">;
};
export type EditGroupRootQuery = {
  response: EditGroupRootQuery$data;
  variables: EditGroupRootQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "accountGroupFilterElement"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "groupUuid"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "policyCollectionFilterElement"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "skip"
},
v4 = [
  {
    "kind": "Variable",
    "name": "uuid",
    "variableName": "groupUuid"
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "roleAssignmentPrincipal",
  "storageKey": null
},
v10 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 100
  }
],
v11 = [
  (v7/*: any*/)
],
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "roleAssignmentTarget",
  "storageKey": null
},
v13 = {
  "kind": "InlineFragment",
  "selections": [
    (v5/*: any*/)
  ],
  "type": "RoleScope",
  "abstractKey": null
},
v14 = {
  "kind": "InlineFragment",
  "selections": (v11/*: any*/),
  "type": "AccountGroup",
  "abstractKey": null
},
v15 = {
  "kind": "InlineFragment",
  "selections": (v11/*: any*/),
  "type": "PolicyCollection",
  "abstractKey": null
},
v16 = {
  "kind": "InlineFragment",
  "selections": (v11/*: any*/),
  "type": "RepositoryConfig",
  "abstractKey": null
},
v17 = {
  "kind": "Literal",
  "name": "first",
  "value": 10
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "uuid",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "userPermissions",
  "storageKey": null
},
v20 = [
  (v7/*: any*/),
  (v18/*: any*/),
  (v12/*: any*/),
  (v19/*: any*/),
  (v6/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "EditGroupRootQuery",
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "AccessControlSettingsPage_query"
      },
      {
        "condition": "skip",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "alias": null,
            "args": (v4/*: any*/),
            "concreteType": "UserGroup",
            "kind": "LinkedField",
            "name": "userGroup",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "source",
                "plural": false,
                "selections": [
                  (v8/*: any*/)
                ],
                "storageKey": null
              },
              (v9/*: any*/),
              {
                "alias": null,
                "args": (v10/*: any*/),
                "concreteType": "RoleAssignmentConnection",
                "kind": "LinkedField",
                "name": "roleAssignments",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RoleAssignmentEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "RoleAssignment",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v6/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Role",
                            "kind": "LinkedField",
                            "name": "role",
                            "plural": false,
                            "selections": (v11/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "target",
                            "plural": false,
                            "selections": [
                              (v8/*: any*/),
                              (v12/*: any*/),
                              (v13/*: any*/),
                              (v14/*: any*/),
                              (v15/*: any*/),
                              (v16/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "roleAssignments(first:100)"
              }
            ],
            "storageKey": null
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "GroupFormFields_query"
          }
        ]
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v3/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "EditGroupRootQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "CurrentUser",
        "kind": "LinkedField",
        "name": "whoami",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "email",
            "storageKey": null
          },
          (v5/*: any*/)
        ],
        "storageKey": null
      },
      {
        "kind": "ClientExtension",
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UrlConfig",
            "kind": "LinkedField",
            "name": "UrlConfig",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "docs",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ]
      },
      {
        "condition": "skip",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "alias": null,
            "args": (v4/*: any*/),
            "concreteType": "UserGroup",
            "kind": "LinkedField",
            "name": "userGroup",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "source",
                "plural": false,
                "selections": [
                  (v8/*: any*/),
                  (v6/*: any*/)
                ],
                "storageKey": null
              },
              (v9/*: any*/),
              {
                "alias": null,
                "args": (v10/*: any*/),
                "concreteType": "RoleAssignmentConnection",
                "kind": "LinkedField",
                "name": "roleAssignments",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RoleAssignmentEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "RoleAssignment",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v6/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Role",
                            "kind": "LinkedField",
                            "name": "role",
                            "plural": false,
                            "selections": [
                              (v7/*: any*/),
                              (v6/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "target",
                            "plural": false,
                            "selections": [
                              (v8/*: any*/),
                              (v12/*: any*/),
                              (v13/*: any*/),
                              (v14/*: any*/),
                              (v15/*: any*/),
                              (v16/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v6/*: any*/)
                                ],
                                "type": "Node",
                                "abstractKey": "__isNode"
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "roleAssignments(first:100)"
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v10/*: any*/),
            "concreteType": "RoleConnection",
            "kind": "LinkedField",
            "name": "roles",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "RoleEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Role",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/),
                      (v7/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "system",
                        "storageKey": null
                      },
                      (v8/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "cursor",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "endCursor",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasNextPage",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "roles(first:100)"
          },
          {
            "alias": null,
            "args": (v10/*: any*/),
            "filters": null,
            "handle": "connection",
            "key": "RolePicker_roles",
            "kind": "LinkedHandle",
            "name": "roles"
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "filterElement",
                "variableName": "accountGroupFilterElement"
              },
              (v17/*: any*/)
            ],
            "concreteType": "AccountGroupConnection",
            "kind": "LinkedField",
            "name": "accountGroups",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "AccountGroupEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AccountGroup",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": (v20/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "filterElement",
                "variableName": "policyCollectionFilterElement"
              },
              (v17/*: any*/)
            ],
            "concreteType": "PolicyCollectionConnection",
            "kind": "LinkedField",
            "name": "policyCollections",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "PolicyCollectionEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PolicyCollection",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v7/*: any*/),
                      (v18/*: any*/),
                      (v19/*: any*/),
                      (v12/*: any*/),
                      (v6/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": [
              (v17/*: any*/)
            ],
            "concreteType": "RepositoryConfigConnection",
            "kind": "LinkedField",
            "name": "repositoryConfigs",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "RepositoryConfigEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RepositoryConfig",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": (v20/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "repositoryConfigs(first:10)"
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "25d62c28d58ca391ea717d1f3f20195d",
    "id": null,
    "metadata": {},
    "name": "EditGroupRootQuery",
    "operationKind": "query",
    "text": "query EditGroupRootQuery(\n  $groupUuid: UUID!\n  $skip: Boolean!\n  $accountGroupFilterElement: FilterElementInput\n  $policyCollectionFilterElement: FilterElementInput\n) {\n  ...AccessControlSettingsPage_query\n  userGroup(uuid: $groupUuid) @skip(if: $skip) {\n    displayName\n    id\n    name\n    source {\n      __typename\n      id\n    }\n    roleAssignmentPrincipal\n    roleAssignments(first: 100) {\n      edges {\n        node {\n          id\n          role {\n            name\n            id\n          }\n          target {\n            __typename\n            roleAssignmentTarget\n            ... on RoleScope {\n              displayName\n            }\n            ... on AccountGroup {\n              name\n            }\n            ... on PolicyCollection {\n              name\n            }\n            ... on RepositoryConfig {\n              name\n            }\n            ... on Node {\n              __isNode: __typename\n              id\n            }\n          }\n        }\n      }\n    }\n  }\n  ...GroupFormFields_query @skip(if: $skip)\n}\n\nfragment AccessControlSettingsPage_query on Query {\n  ...PageWithBreadCrumbs_query\n}\n\nfragment AccountGroupPicker_accountGroups_4i7Unr on Query {\n  accountGroups(filterElement: $accountGroupFilterElement, first: 10) {\n    edges {\n      node {\n        name\n        uuid\n        roleAssignmentTarget\n        userPermissions\n        id\n      }\n    }\n  }\n}\n\nfragment BreadCrumbsHeader_query on Query {\n  whoami {\n    email\n    displayName\n  }\n}\n\nfragment GroupFormFields_query on Query {\n  ...RolePicker_roles\n  ...ScopePicker_scopes\n}\n\nfragment PageWithBreadCrumbs_query on Query {\n  ...BreadCrumbsHeader_query\n}\n\nfragment PolicyCollectionPicker_policyCollections_4i7Unr on Query {\n  policyCollections(filterElement: $policyCollectionFilterElement, first: 10) {\n    edges {\n      node {\n        name\n        uuid\n        userPermissions\n        roleAssignmentTarget\n        id\n      }\n    }\n  }\n}\n\nfragment RepositoryPicker_repositoryConfigs_4i7Unr on Query {\n  repositoryConfigs(first: 10) {\n    edges {\n      node {\n        name\n        uuid\n        roleAssignmentTarget\n        userPermissions\n        id\n      }\n    }\n  }\n}\n\nfragment RolePicker_roles on Query {\n  roles(first: 100) {\n    edges {\n      node {\n        id\n        name\n        system\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment ScopePicker_scopes on Query {\n  ...AccountGroupPicker_accountGroups_4i7Unr\n  ...PolicyCollectionPicker_policyCollections_4i7Unr\n  ...RepositoryPicker_repositoryConfigs_4i7Unr\n}\n"
  }
};
})();

(node as any).hash = "cc8fead15e5ec543bf1c307201e6114e";

export default node;
